import { Donor, DonorSchedule, UpsertPartnershipInput } from '@/rtk-query.gql';

export type AccountType = {
  id: string | null;
  name: string | null;
};

export enum PartnershipsActions {
  UPDATE_SHOW = 'partnerships/UPDATE_SHOW',
  UPDATE_PARTNERSHIP = 'partnerships/UPDATE_PARTNERSHIP',
  UPDATE_PARTNERSHIP_ACCOUNT = 'partnerships/UPDATE_PARTNERSHIP_ACCOUNT',
  UPDATE_PARTNERSHIP_PERCENT = 'partnerships/UPDATE_PARTNERSHIP_PERCENT',
  RESET_PARTNERSHIP = 'partnerships/RESET_PARTNERSHIP',
}

export type PartnershipItemType = {
  __typename?: string;
  id: string | null;
  name: string | null;
  stateCode: number | null;
  partnershipBillingType?: number | null;
  account1: AccountType | null;
  account2: AccountType | null;
  account3: AccountType | null;
  account4: AccountType | null;
};
export type PartnershipType = {
  donor: Donor | null;
  donorSchedule: DonorSchedule | null;
} & PartnershipItemType &
  UpsertPartnershipInput;

export type PartnershipsType = {
  show: boolean;
  partnership: PartnershipType[];
};

export const initialPartnershipItemFormState = {
  account1: null,
  account1Id: null,
  account2: null,
  account2Id: null,
  account3: null,
  account3Id: null,
  account4: null,
  account4Id: null,
  donor: null,
  donorId: null,
  donorSchedule: null,
  donorScheduleId: null,
  oddEven1: null,
  oddEven2: null,
  oddEven3: null,
  oddEven4: null,
  partnershipBillingType: null,
  percent1: null,
  percent2: null,
  percent3: null,
  percent4: null,
  type: null,
  viewOnline1: null,
  viewOnline2: null,
  viewOnline3: null,
  viewOnline4: null,
} as PartnershipType;

export const initialPartnershipFormState = [
  { ...initialPartnershipItemFormState, type: 100000000 },
  { ...initialPartnershipItemFormState, type: 100000001 },
  { ...initialPartnershipItemFormState, type: 100000002 },
  { ...initialPartnershipItemFormState, type: 100000003 },
  { ...initialPartnershipItemFormState, type: 100000004 },
  { ...initialPartnershipItemFormState, type: 100000005 },
  { ...initialPartnershipItemFormState, type: 100000006 },
  { ...initialPartnershipItemFormState, type: 100000007 },
];

export const initialState: PartnershipsType = {
  show: false,
  partnership: initialPartnershipFormState,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function reducer(state = initialState, action: any) {
  switch (action.type) {
    case PartnershipsActions.UPDATE_SHOW: {
      return {
        ...state,
        show: action.payload,
      };
    }
    case PartnershipsActions.UPDATE_PARTNERSHIP: {
      return {
        ...state,
        partnership: action.payload,
      };
    }
    case PartnershipsActions.UPDATE_PARTNERSHIP_ACCOUNT: {
      let accountIndex = null;

      if (
        action.partnership.account1Id !==
        state.partnership.find((p) => p.type === action.partnership.type)
          ?.account1Id
      ) {
        accountIndex = 1;
      }

      if (
        action.partnership.account2Id !==
        state.partnership.find((p) => p.type === action.partnership.type)
          ?.account2Id
      ) {
        accountIndex = 2;
      }

      if (
        action.partnership.account3Id !==
        state.partnership.find((p) => p.type === action.partnership.type)
          ?.account3Id
      ) {
        accountIndex = 3;
      }

      if (
        action.partnership.account4Id !==
        state.partnership.find((p) => p.type === action.partnership.type)
          ?.account4Id
      ) {
        accountIndex = 4;
      }

      return {
        ...state,
        partnership: [...state.partnership].map((p) => {
          return {
            ...p,
            [`account${accountIndex}`]:
              action.partnership[`account${accountIndex}`],
            [`account${accountIndex}Id`]:
              action.partnership[`account${accountIndex}Id`],
          };
        }),
      };
    }
    case PartnershipsActions.UPDATE_PARTNERSHIP_PERCENT: {
      const { partnership } = action;
      const updatedPartnership = state.partnership.map((p) => {
        if (p.type === action.partnership.type) {
          const updatedFields = Object.keys(partnership).filter((key) =>
            key.startsWith('percent'),
          );

          const updatedPartnership = { ...p } as PartnershipType;
          updatedFields.forEach((field) => {
            (updatedPartnership[field as keyof PartnershipType] as
              | number
              | null) = partnership[field as keyof PartnershipType] as
              | number
              | null;
          });

          return updatedPartnership;
        }

        if (action.partnership.type === 100000000) {
          const updatedPartnership = { ...p };
          ['percent1', 'percent2', 'percent3', 'percent4'].forEach((field) => {
            if (
              p[field as keyof PartnershipType] === null &&
              partnership[field] !== undefined
            ) {
              (updatedPartnership[field as keyof PartnershipType] as
                | number
                | null) = partnership[field as keyof PartnershipType] as
                | number
                | null;
            }
          });

          return updatedPartnership;
        }

        return p;
      });

      return {
        ...state,
        partnership: updatedPartnership,
      };
    }
    case PartnershipsActions.RESET_PARTNERSHIP: {
      return {
        ...state,
        partnership: initialPartnershipFormState,
      };
    }
    default:
      return state;
  }
}
